'use strict';

class EditProject {
  constructor($location, $routeParams, $scope, $window, $sce, $filter, timeTrackingService, recipientService, I18N) {
    this.$location = $location;
    this.$scope = $scope;
    this.$window = $window;
    this.$sce = $sce;
    this.$filter = $filter;
    this.timeTrackingService = timeTrackingService;
    this.recipientService = recipientService;

    this.I18N = I18N;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.alert = {};

    this.recipient = null;

    this.project = {
      number: null,
      name: null,
      recipientNumber: null,
      tasks: [{
        number: null,
        projectNumber: null,
        name: null
      }]
    };

    this.loadProject();

    this.$scope.$on('selectedRecipient', (e, val) => {
      //setup placeholders
      this.recipient = null;

      if (val) {
        //copy data anyways for preview
        this.recipient = {
          customerNumber: val.customerNumber,
          name: val.name,
          contact: {
            address: val.address,
            email: val.email === '' ? null : val.email,
            phone: null,
            mobile: val.mobile === '' ? null : val.mobile,
            fax: null,
            web: null
          },
          organisation: {
            form: null,
            icd: val.icd === '' ? null : val.icd,
            number: val.organisationNumber === '' ? null : val.organisationNumber
          },
          settings: {
            discount: 0,
            creditDays: null,
            defaultShipment: 'EMAIL',
            currency: null
          },
          avtaleGiro: null,
          yourReference: null,
          customFields: [],
          comment: null,
          labels: val.labels || null
        };

        if (typeof val.number !== 'undefined') {
          this.project.recipientNumber = val.number;
          this.recipient.contact.mobile = val.mobile;
        } else {
          this.project.recipientNumber = null;
        }
      } else {
        this.recipient = null;
        this.project.recipientNumber = null;
      }
    });
  }

  add() {
    this.project.tasks.push(
      {
        number: null,
        projectNumber: this.project.number,
        name: null
      });
  }

  remove(index) {
    if (!this.project.tasks[index].deletable) {
      swal('Oppgaven kan ikke fjernes da den har blitt brukt i timeregistrering.');
      return;
    }
    this.project.tasks.splice(index, 1);
  }

  loadProject() {
    if (this.number) {
      this.timeTrackingService.getProject(this.number)
        .then((resp) => {
          this.project = resp.data;
        });
    }
  }

  saveOrUpdate() {
    $('input').removeClass('error');
    $('input').removeClass('ng-invalid');
    $('label').removeClass('error');

    this.alert = null;
    if (!this.recipient || this.$filter('isEmptyObject')(this.recipient) || !this.recipient.name) {
      this.alert = {
        type: 'error',
        message: 'Mottager er påkrevd'
      };
      return;
    }

    if (!this.project.recipientNumber) {
      // save recipient first
      if (this.recipient && this.recipient.name) {
        this.recipientService.save(this.recipient)
          .then((resp) => {
            let nr = resp.headers('location');
            if (nr) {
              this.project.recipientNumber = this.$filter('urlParser')(nr, 4);
              this.processSaveOrUpdate();
            }
          });
      }
    }
    this.processSaveOrUpdate();
  }

  processSaveOrUpdate() {
    let clone = angular.copy(this.project);

    if (clone.tasks.length) {
      clone.tasks.forEach((task) => {
        task.hourlyRate = this.$filter('defaultValue')(this.$filter('numberify')(task.hourlyRate), null);
        return task;
      }, this);
    }

    if (this.project.number) {
      // update existing product
      this.timeTrackingService.updateProject(this.project.number, clone)
        .then(() => this.$location.path('/timeregistrering/prosjekter'));
    } else {
      // new product
      this.timeTrackingService.saveProject(clone)
        .then(() => this.$location.path('/timeregistrering/prosjekter'))
        .catch(() => {
          // reset the form
          this.project = clone;
        });
    }
  }

  deleteProject() {
    swal({
      title: 'Bekreft sletting av prosjektet',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.timeTrackingService.deleteProject(this.project.number)
          .then(() => {
            swal({
              title: 'Prosjektet ble slettet OK',
              type: 'success',
              confirmButtonColor: '#004b8d'
            }, () => {
            });
            this.$location.path('/timeregistrering/prosjekter');
          })
          .catch(() => {
            swal.close();
          });
      }
    });
  }

  loadTasks(projectNumber) {
    this.tasks = [];
    if (projectNumber === 1) {
      this.tasks.push({
        number: 1,
        name: 'Software development 1'
      });
      this.tasks.push({
        number: 2,
        name: 'Software development 2'
      });
    } else if (projectNumber === 2) {
      this.tasks.push({
        number: 3,
        name: 'Design  1'
      });
      this.tasks.push({
        number: 4,
        name: 'Design  2'
      });
    } else if (projectNumber === 3) {
      this.tasks.push({
        number: 5,
        name: 'Test task'
      });
      this.tasks.push({
        number: 6,
        name: 'Sample task'
      });
    }
  }

  editProject(index) {
    let clone = angular.copy(this.selectedDayEntries[index]);
    this.loadTasks(clone.projectNumber);
    this.project = clone;
  }
}

EditProject.$inject = ['$location', '$routeParams', '$scope', '$window', '$sce', '$filter', 'timeTrackingService', 'recipientService', 'I18N'];

const editProject = {
  controller: EditProject,
  templateUrl: 'time-track/edit-project.html'
};

angular
  .module('SendRegning')
  .component('editProject', editProject)
  .config(($routeProvider) => {
    $routeProvider
      .when('/timeregistrering/prosjekt', {
        title: 'Prosjekt',
        template: '<edit-project />',
        secure: true
      })
      .when('/timeregistrering/prosjekt/:number', {
        title: 'Prosjekt',
        template: '<edit-project />',
        secure: true
      });
  });
